export default {
      id: "playback__video-group-usage",
      viewBox: "0 0 50 34",
      url: __webpack_public_path__ + "img/icons.svg#playback__video-group",
      toString: function () {
        return this.url;
      }
    }